import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from 'react-query';
import Routing from '../utils/routes';
import Header from '../components/Header';

const ServicetjekAarligt30 = (props: { resultatLink: string; adgangTilServicetjek: boolean; aarligtServicetjekLink: string; yearTwo: boolean; erMedlem: boolean; pensionsAlder: number; }) => {
	const { resultatLink, adgangTilServicetjek, aarligtServicetjekLink, yearTwo, erMedlem, pensionsAlder } = props;
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: false
			}
		}
	});
	const baseRoot = aarligtServicetjekLink;

	return (
		<QueryClientProvider client={ queryClient }>
			<Header baseUrl={ baseRoot } title={ 'Servicetjek' } />
			<BrowserRouter basename={ baseRoot }>
				<Routing resultUrl={ resultatLink } servicecheckAccess={ adgangTilServicetjek } yearTwo={ yearTwo } erMedlem={ erMedlem } pensionsAlder={ pensionsAlder } />
			</BrowserRouter>
		</QueryClientProvider>
	);
};

export default ServicetjekAarligt30;